// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"75e8f6e0","981":"264d3e26"}[chunkId] + ".chunk.js";
};